import React from "react";
import moment from "moment";
import { css } from "aphrodite";
import { snakeCase } from "lodash";
import { Col, Row } from "react-bootstrap";
import TimelineStyle from "./TimelineStyle";
import TextArea from "../GenericComponents/TextArea";

const DiaryDetailsContent = (props) => {
  switch (props.eventType) {
    case "bleeds":
      return prepareDetailsViewForBleeds(props.data, props.imgUrl);
    case "abnormalMotion":
      return prepareDetailsViewForAbnormalMotion(props.data);
    case "hrmLogs":
      return prepareDetailsViewForHRMLogs(props.data);
    case "visits":
      return prepareDetailsViewForVisits(props.data);
    case "allergy":
      return prepareDetailsViewForAllergies(props.data);
    case "help":
      return prepareDetailsViewForHelp(props.data);
    case "treatmentLogs":
      return prepareDetailsViewForTreatmentLogs(props.data, props.imgUrl);
    case "symptoms":
      return prepareDetailsViewForSymptoms(props.data);
    default:
      return null;
  }
};

const prepareDetailsViewForBleeds = (data, imgUrl) => {
  //console.log("data...", data);
  return (
    <div>
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          color: "#FFF",
          fontSize: "14px",
        }}
      >
        <div>
          <span style={{ opacity: "0.5" }}>DATE / TIME</span>
          <br />
          <span>
            {moment.unix(data.timestamp / 1000).format("MM/DD/YYYY hh:mm a")}
          </span>
        </div>
      </div>
      <div
        className={css([TimelineStyle.contentNoShadow])}
        key={`${data.type.replace(new RegExp(" ", "g"), "_")}`}
      >
        <Row
          style={{ padding: "15px 20px", marginRight: "0px" }}
          key={`bleeds_${data.type.replace(new RegExp(" ", "g"), "_")}`}
        >
          <Col
            xs={12}
            sm={6}
            md={3}
            style={{
              textAlign: "center",
            }}
          >
            <img
              src={"/images/diary/bleeds_card_icon.png"}
              alt={`bleeds_card_icon_alt`}
              style={{
                paddingTop: "10px",
              }}
            />
          </Col>
          <Col xs={12} sm={6} md={9} style={{ verticalAlign: "middle" }}>
            <Row>
              <Col>
                <div
                  style={{
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{data.type}</span>
                  <br />
                  <span>{data.description}</span>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div style={{ color: "#FFF" }}>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span style={{ fontSize: "14px" }}>
            {data.bleedCause
              ? data.bleedCause.replace(new RegExp("_", "g"), " ")
              : "no bleed cause reported"}
          </span>
        </div>
        <div style={{ textAlign: "center", color: "#000" }}>
          <TextArea
            rows={4}
            name={"diseaseConditionDesc"}
            value={data.notes}
            className={css([
              TimelineStyle.contentNoShadow,
              TimelineStyle.eventAreaStyle,
            ])}
            disabled={true}
          />
        </div>
        <div>
          {imgUrl.map((bleedImg, index) => {
            return (
              <div style={{ marginBottom: "1em" }}>
                <img src={bleedImg.img} width="245" height="140" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const prepareDetailsViewForAbnormalMotion = (data) => {
  return (
    <div className={css([TimelineStyle.bgDiv])}>
      <div style={{ color: "#FFF" }}>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "14px",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              {data.type}
            </span>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            textTransform: "uppercase",
          }}
        >
          <span style={{ fontSize: "14px", textTransform: "capitalize" }}>
            {data.description}
          </span>
          <div style={{ marginTop: "20px" }}>
            <span style={{ opacity: "0.5" }}>DATE / TIME</span>
            <br />
            <span>
              {moment.unix(data.timestamp / 1000).format("MM/DD/YYYY hh:mm a")}
            </span>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>DURATION</span>
          <br />
          <span style={{ fontSize: "16px" }}>
            {" "}
            {data.duration >= 60
              ? `${Math.floor(data.duration / 60)} min ${data.duration - Math.floor(data.duration / 60) * 60
              } sec`
              : `${data.duration} seconds`}
          </span>
        </div>
        {data.minHr && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>MIN HR</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.minHr}</span>
          </div>
        )}
        {data.maxHr && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>MAX HR</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.maxHr}</span>
          </div>
        )}
        {data.avgHr && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>AVG HR</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.avgHr}</span>
          </div>
        )}
        {data.address && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>ADDRESS</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.address}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const prepareDetailsViewForHRMLogs = (data) => {
  return (
    <div className={css([TimelineStyle.bgDiv])}>
      <div style={{ color: "#FFF" }}>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "14px",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              {data.type}
            </span>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            textTransform: "uppercase",
          }}
        >
          <span style={{ fontSize: "14px", textTransform: "capitalize" }}>
            {data.description}
          </span>
          <div style={{ marginTop: "20px" }}>
            <span style={{ opacity: "0.5" }}>DATE / TIME</span>
            <br />
            <span>
              {moment.unix(data.timestamp / 1000).format("MM/DD/YYYY hh:mm a")}
            </span>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>DURATION</span>
          <br />
          <span style={{ fontSize: "16px" }}>
            {" "}
            {data.duration >= 60
              ? `${Math.floor(data.duration / 60)} min ${data.duration - Math.floor(data.duration / 60) * 60
              } sec`
              : `${data.duration} seconds`}
          </span>
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>MIN HR</span>
          <br />
          <span style={{ fontSize: "16px" }}>{data.minHr}</span>
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>MAX HR</span>
          <br />
          <span style={{ fontSize: "16px" }}>{data.maxHr}</span>
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>AVG HR</span>
          <br />
          <span style={{ fontSize: "16px" }}>{data.avgHr}</span>
        </div>
        {data.address && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>ADDRESS</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.address}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const prepareDetailsViewForVisits = (data) => {
  return (
    <div className={css([TimelineStyle.bgDiv])}>
      <div style={{ color: "#FFF" }}>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "14px",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              {data.isPlannedVisit
                ? `PLANNED MEDICAL VISIT/ ADMISSION`
                : `UNPLANNED MEDICAL VISIT/ ADMISSION`}
            </span>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            textTransform: "uppercase",
          }}
        >
          <span style={{ fontSize: "14px", textTransform: "capitalize" }}>
            {data.description}
          </span>
        </div>
        <div style={{ textAlign: "center" }}>
          <span style={{ fontSize: "12px", opacity: "0.5" }}>ADMISSION ON</span>
        </div>

        <div style={{ textAlign: "center" }}>
          <span style={{ fontSize: "16px" }}>
            {data.umvDate
              ? `${moment(data.umvDate).format("MMM DD, YYYY")} AT ${moment(
                data.umvDate
              ).format("hh:mm a")}`
              : `${moment(data.timestamp).format("MMM DD, YYYY")} AT ${moment(
                data.timestamp
              ).format("hh:mm a")}`}
          </span>
        </div>

        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>
            FACILITY NAME
          </span>
        </div>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span style={{ fontSize: "16px" }}>{data.facilityName}</span>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>REASON</span>
        </div>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span style={{ fontSize: "16px" }}>{data.reason}</span>
        </div>

        {data.notes ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>NOTES</span>
          </div>
        ) : null}

        {data.notes ? (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <span style={{ fontSize: "16px" }}>{data.notes}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const prepareDetailsViewForAllergies = (data) => {
  return (
    <div className={css([TimelineStyle.bgDiv])}>
      <div style={{ color: "#FFF" }}>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "14px",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              {data.eventType}
            </span>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>ALLERGIC TO</span>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            textTransform: "capitalize",
          }}
        >
          <span style={{ fontSize: "16px" }}>{data.description}</span>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>MEDICATION</span>
        </div>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span style={{ fontSize: "16px" }}>{data.medicationName}</span>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>SEVERITY</span>
        </div>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span style={{ fontSize: "16px" }}>{data.severity}</span>
        </div>

        {data.reactions.length !== 0 && (
          <>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <span style={{ fontSize: "14px", opacity: "0.5" }}>
                ALLERGIC REACTIONS
              </span>
            </div>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              {[
                ...data.reactions.map((reaction, index) => {
                  return (
                    <div>
                      <span style={{ fontSize: "16px" }}>
                        {reaction.reactionName}
                        {/* {obj.reactions.length > 1 ? " ," : null} */}
                      </span>
                      <br />
                    </div>
                  );
                }),
              ]}
            </div>
          </>
        )}
        {data.notes ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>NOTES</span>
          </div>
        ) : null}

        {data.notes ? (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <span style={{ fontSize: "16px" }}>{data.notes}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const prepareDetailsViewForHelp = (data) => {
  return (
    <div>
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          color: "#FFF",
          fontSize: "14px",
        }}
      >
        <div>
          <span style={{ opacity: "0.5" }}>DATE / TIME</span>
          <br />
          <span>
            {moment.unix(data.timestamp / 1000).format("MM/DD/YYYY hh:mm a")}
          </span>
        </div>
      </div>
      <div
        className={css([TimelineStyle.contentNoShadow])}
        key={`${data.type.replace(new RegExp(" ", "g"), "_")}`}
      >
        <Row
          style={{ padding: "15px 20px", marginRight: "0px" }}
          key={`bleeds_${data.type.replace(new RegExp(" ", "g"), "_")}`}
        >
          <Col
            xs={12}
            sm={6}
            md={3}
            style={{
              textAlign: "center",
            }}
          >
            <img
              src={"/images/diary/help_card_icon.png"}
              alt={`bleeds_card_icon_alt`}
              style={{
                paddingTop: "10px",
              }}
            />
          </Col>
          <Col xs={12} sm={6} md={9} style={{ verticalAlign: "middle" }}>
            <Row>
              <Col>
                <div
                  style={{
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{data.type}</span>
                  <br />
                  <span>{data.description}</span>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div style={{ color: "#FFF" }}>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <span
            style={{ fontSize: "14px", textAlign: "center", opacity: "0.5" }}
          >
            ADDRESS
          </span>
        </div>
        <div style={{ textAlign: "center", color: "#000" }}>
          <TextArea
            rows={4}
            name={"diseaseConditionDesc"}
            value={data.address}
            className={css([
              TimelineStyle.contentNoShadow,
              TimelineStyle.eventAreaStyle,
            ])}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

const prepareDetailsViewForTreatmentLogs = (data, imgUrl) => {
  //console.log("data...", data);
  return (
    <div>
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          color: "#FFF",
          fontSize: "14px",
        }}
      >
        <div>
          <span style={{ opacity: "0.5" }}>DATE / TIME</span>
          <br />
          <span>
            {moment.unix(data.timestamp / 1000).format("MM/DD/YYYY hh:mm a")}
          </span>
        </div>
      </div>
      <div
        className={css([TimelineStyle.contentNoShadow])}
        key={`${data.type.replace(new RegExp(" ", "g"), "_")}`}
      ></div>
      <div style={{ color: "#FFF" }}></div>
    </div>
  );
};

const prepareDetailsViewForSymptoms = (data) => {
  return (
    <div className={css([TimelineStyle.bgDiv])}>
      <div style={{ color: "#FFF" }}>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <div>
            <span
              style={{
                fontSize: "14px",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              {data.type}
            </span>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            textTransform: "uppercase",
          }}
        >
          <span style={{ fontSize: "14px", textTransform: "capitalize" }}>
            {data.description}
          </span>
          <div style={{ marginTop: "20px" }}>
            <span style={{ opacity: "0.5" }}>DATE / TIME</span>
            <br />
            <span>
              {moment.unix(data.timestamp / 1000).format("MM/DD/YYYY hh:mm a")}
            </span>
          </div>
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span style={{ fontSize: "14px", opacity: "0.5" }}>SEVERITY</span>
          <br />
          <span style={{ fontSize: "16px" }}>
            {" "}
            {data.severity}
          </span>
        </div>
        {data.duration && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>DURATION</span>
            <br />
            <span style={{ fontSize: "16px" }}>
              {" "}
              {data.duration}
            </span>
          </div>
        )}
        {data.otherSymptom && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>OTHER SYMPTOM</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.otherSymptom}</span>
          </div>
        )}
        {data.symptomDescription && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span style={{ fontSize: "14px", opacity: "0.5" }}>SYMPTOM DESCRIPTION</span>
            <br />
            <span style={{ fontSize: "16px" }}>{data.symptomDescription}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiaryDetailsContent;
